/**
Copyright (C) 2018 Andras Sarvari <andras.sarvari@sarvaria.net>

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted, provided that the above
copyright notice and this permission notice appear in all copies.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR
ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN
ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF
OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
*/

/* jshint browser: true, esversion: 6, node:true */
/* globals console */

import React from 'react';
import Snackbar from '../../Snackbar/Snackbar';
import Screen from '../Screen';
import Service from '../../Util/Service';
import './BusinessReport.css';

/**
 * Represents the business report screen.
 */

export default class BusinessReport extends Screen {

    /**
     * Default state.
     */

    state = {
        report:             []
    }

    /** 
     * Event that fires when the screen mounted.
     */

    componentDidMount() {

        // Setting actionbar title

        this.props.onSetActionbarTitle(this.props.context.locale.businessreport.title);

        // Showing progress indicator

        this.props.onLoading(true);

        // Loading the business report

        Service.loadBusinessReport().then((report) => {

            // Storing the report result

            this.setState({ report: report }, () => {

                // Hiding progress indicator

                this.props.onLoading(false);
            });
        }).catch((error) => {

            // Showing error

            this.snackbar.show(this.props.context.locale.error.database, true);

            // Hiding progress indicator

            this.props.onLoading(false);
        });                    
    }

    /** 
     * Settings screen renderer.
     */

    render() {

        // Colors

        const COLORS = [ '#E1F5FE', '#B3E5FC', '#81D4FA', '#4FC3F7', '#29B6F6', '#03A9F4', '#039BE5', '#0288D1' ];

        return (
            <div className="businessreport">

                {/* Business report container */}

                <div className="businessreport-container horizontal wrap">
                    { this.state.report.map((item, index) => 
                        <div key={index} className="businessreport-group vertical center center-justified" style={{ backgroundColor: COLORS[index % 8]}}>
                            <div className="businessreport-group-name">{item.id}</div>
                            <div className="horizontal" style={{ width: '96%' }}>
                                <div className="businessreport-group-count">{`${this.props.context.locale.businessreport.count}: `}</div>
                                <div className="businessreport-group-count-value">{`${item.entities.count}`}</div>
                                <div className="flex"></div>
                                <div className="businessreport-group-sum">{`${this.props.context.locale.businessreport.sum}: `}</div>
                                <div className="businessreport-group-sum-value">{`${item.entities.sum} ${this.props.context.locale.businessreport.currency}`}</div>
                            </div>
                        </div>
                    )}
                </div>

                {/* Snackbar */}

                <Snackbar ref={c => {this.snackbar = c;}} />                
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Screens/BusinessReport/BusinessReport.js